// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"styles_formTitle__ieDLB","formLinks":"styles_formLinks__3VRX-","noAccountText":"styles_noAccountText__AbPP8","submitBtn":"styles_submitBtn__2I4HB"};